import newRelicAgent from 'utilities/monitoring/newRelic'

const init = () => {
  newRelicAgent.init()
}

const noticeError = (error: any = new Error('myQAP Front-end Portal'), attributes: any = {}) => {
  newRelicAgent.noticeError(error, attributes)
}

const setAPIReleaseVersion = (apiVersion = '') => {
  newRelicAgent.setAPIReleaseVersion(apiVersion)
}

const setUserId = (userId?: string | null) => {
  newRelicAgent.setUserId(userId)
}

const recordBrowserDisplayAttributes = () => {
  newRelicAgent.recordBrowserDisplayAttributes()
}

export default {
  init,
  noticeError,
  setAPIReleaseVersion,
  setUserId,
  recordBrowserDisplayAttributes,
}
